/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription } from "@repo/ui";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { PATHS } from "routes/paths";
import { useGetVaultedTickets } from "services/tickets";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import { FiltersContext } from "store/filters-context";
import TaskFilterBarV2 from "components/tickets/tasks-filter-bar";
import { StatusContext } from "../constants";
import { fixKendoGridContent, isFilterUpdated } from "../utils";
import GridDataCopyCell from "components/copy";
import SLACell from "../common/SLACell";

export default function CCAVaultedTicketsList() {
  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  });
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const { setStatus } = useContext(StatusContext);
  const { filters } = useContext(FiltersContext);
  const [localFilters, setLocalFilters] = useState({
    searchCriteria: filters?.searchCriteria?.value || "",
    period: filters?.period?.value || "All",
    cashCenterId: filters?.cashCenterId?.value || "",
    customerId: filters?.customerId?.value || "",
    assetId: filters?.assetId?.value || "",
    activityType: filters?.activityType?.value || "",
    assignmentGroup: filters?.assignmentGroup?.value || "",
    routeNo: filters?.routeNo?.value || "",
    assignedTo: filters?.assignedTo?.value || "",
  });
  const pageSize = 100;

  useEffect(() => {
    const nextFilters = {
      searchCriteria: filters?.searchCriteria?.value || "",
      period: filters?.period?.value || "All",
      cashCenterId: filters?.cashCenterId?.value || "",
      customerId: filters?.customerId?.value || "",
      assetId: filters?.assetId?.value || "",
      activityType: filters?.activityType?.value || "",
      assignmentGroup: filters?.assignmentGroup?.value || "",
      routeNo: filters?.routeNo?.value || "",
      assignedTo: filters?.assignedTo?.value || "",
    };

    if (isFilterUpdated(localFilters, nextFilters)) {
      setLocalFilters({ ...nextFilters });
    }
  }, [filters]);
  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
    reset: resetGetTickets,
  } = useGetVaultedTickets();

  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      ...localFilters,
    });
  }, [localFilters]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(ticketsList.data.data);
      resetGetTickets();
    }
  }, [ticketsList]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      pageNumber: _page,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  const onRefresh = () => {
    getTickets({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };
  return (
    <div className="box-border">
      {gettingTickets ? <Loader /> : <></>}
      <BreadCrumb
        className="mx-4"
        items={[
          { text: "Dashboard", to: "/" },
          { text: "Vault Access Tickets" },
        ]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <TaskFilterBarV2 hideStatus onRefresh={onRefresh} />
          </CardDescription>

          <Grid
            data={process(tickets || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              e.dataState.skip = 0;
              setDataState(e.dataState);
            }}
            className="list-tables-v1"
            filterable
            width="100%"
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <GridColumn
              title="Open At"
              field="createDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            {/* <GridColumn
              title="Resolve At"
              field="resolvedDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            /> */}
            <GridColumn
              title="Duration"
              headerClassName="text-center"
              field="sla"
              width="150px"
              cell={SLACell}
            />
            <GridColumn
              title="State"
              field="status"
              width="150px"
              className="text-center"
              headerClassName="text-center"
              filterable
            />

            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn
              title="Ticket Number"
              width="170px"
              field="caseNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("vaultAccess");
                          }}
                          to={
                            dataItem.status === "Draft"
                              ? `${PATHS.createTicket}/${dataItem.ticketId}`
                              : `${PATHS.ticketDetails}/${dataItem.ticketId}`
                          }
                        >
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.caseNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />
            <GridColumn
              title="Task Number"
              width="170px"
              field="taskNo"
              cell={({ dataItem }) => (
                <td>
                  <Link
                    onClick={() => {
                      setStatus("vaultAccess");
                    }}
                    to={`${PATHS.taskDetails}/${dataItem.requestId}`}
                  >
                    {dataItem.status === "Draft"
                      ? "View Draft"
                      : dataItem.taskNo}
                  </Link>
                </td>
              )}
            />
            <GridColumn
              title="Bank Reference/Address"
              field="customerTicketNo"
              width="200px"
            />
            <GridColumn
              title="Activity Type"
              field="serviceType"
              width="170px"
            />
            <GridColumn title="Category" field="fault" width="150px" />
            <GridColumn
              title="Sub Category"
              field="faultDetails"
              width="150px"
            />
            <GridColumn title="Route No" field="routeNo" width="150px" />
            <GridColumn title="Assigned To" field="assigneeId" width="150px" />
            <GridColumn
              title="Secondary Assignee"
              field="secondaryAssigneeId"
              width="220px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn title="Description" field="remarks" width="400px" />
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}
